import { Component, OnInit, Input, Output, EventEmitter, DoCheck } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { TrainingCentersService } from 'projects/services/src/app/API/training-centers.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { SharedService } from 'projects/services/src/app/shared/shared.service';
import { Facility } from 'src/app/models/facility';
import { TrainingPartnerService } from 'projects/services/src/app/API/training-partner.service';
import { STATE } from 'projects/training-partner/src/app/training-partner/constants';
declare var toastr: any;
declare const swal: any;


@Component({
	selector: 'app-view-tc-photos-through-mobile-apk-review-and-submit',
	templateUrl: './view-tc-photos-through-mobile-apk-review-and-submit.component.html',
	styleUrls: ['./view-tc-photos-through-mobile-apk-review-and-submit.component.css']
})
export class ViewTcPhotosThroughMobileApkReviewAndSubmitComponent implements OnInit, DoCheck {

	reviewCommentsForm: FormGroup;
	mobileForm: FormGroup;
	reviewCommentsForForm: FormGroup;
	prevImg: any;
	tcworkflow: any;
	reviewsOfCma: any;
	showData: any;
	modalImage: any;
	tcData: any;
	@Input() amdinNstate: any;
	@Output() reviewDataPhotos: any = new EventEmitter;
	showReviewsInTp = false;
	readonly STATE = STATE;
	countOfPhotos = 0;
	countOfPhotosExit = 0;
	isCountOfphotosAndcountOfPhotosExitSame = false;
	called = false;
	role: any;
	objectKeys = Object.keys;
	status: any;
	photosAsArray: any = [];
	commentsValidationArray: any = [];
	reviews: FormArray;
	isSchemeIdGrameenUdhyami = false;
	schemeID: any;

	constructor(
		public route: ActivatedRoute,
		public location: Location,
		private router: Router,
		private fb: FormBuilder,
		private trainingcentreservice: TrainingCentersService,
		private tps: TrainingPartnerService,
		private sharedService: SharedService,
		private fileService: FileService
	) {

		this.schemeID = this.route.snapshot.queryParams.selectedSchemeId;

		this.reviewCommentsForForm = this.fb.group({
			review: ['', [Validators.required]],
			comment: ['']
		});

		this.mobileForm = this.fb.group({
			mobileNumber: ['', [Validators.required]],
			email: ['', [Validators.required]],
		});

		this.reviewCommentsForm = this.fb.group({
			reviews: this.fb.array([])
		});
		if (this.route.snapshot.params && this.route.snapshot.params.selectedSubSchemeName == 'Grameen Udhyami') {
			this.isSchemeIdGrameenUdhyami = true;
		}
	}

	ngOnInit() {
		this.tcworkflow = this.trainingcentreservice.getTcWorkflowData();
		this.getTc();
	}

	createReviews(facility, photos, key, review): FormGroup {
		return this.fb.group({
			[facility]: photos,
			facility: key.toString(),
			review: [{
				value: review && review[key] ? (review[key].review === 'Document Required' &&
					this.amdinNstate && this.amdinNstate.admin ? '' : review[key].review) : '',
				disabled: review && review[key] && review[key].review === 'approved' &&
					this.amdinNstate && this.amdinNstate.admin
			}, [Validators.required]],
			comment: [{
				value: review && review[key] ? (review[key].review === 'Document Required' &&
					this.amdinNstate && this.amdinNstate.admin ? '' : review[key].comment) : '',
				disabled: review && review[key] && review[key].review === 'approved' &&
					this.amdinNstate && this.amdinNstate.admin
			}
			],
		});
	}

	removeControls() {
		const a = this.reviewCommentsForm.get('reviews').value;
		if (a.length !== 0) {
			for (let i = 0; i < a.length; i++) {
				this.reviews.removeAt(i);
				this.reviews.removeAt(0);
			}
		}
	}

	getTc() {
		this.countOfPhotos = 0;
		this.countOfPhotosExit = 0;
		this.removeControls();
		this.photosAsArray.length = 0;
		this.trainingcentreservice.getTrainingCentre(this.route.snapshot.params.tcId).subscribe(res => {
			this.tcData = res;
			this.status = res.status;
			if (res.spoc) {
				this.mobileForm.patchValue(res.spoc);
			}
			this.addFacilityPhotosInArray();
			this.showData = Object.keys(res.photos).length !== 0 ? true : this.isSchemeIdGrameenUdhyami ? true : false;
			if (res.cmaReviews && typeof (res.cmaReviews) === 'object') {
				!this.amdinNstate.admin && res.cmaReviews.length !== 0 ? this.showReviewsInTp = true : this.showReviewsInTp = false;
			}
			if (this.amdinNstate.admin) {
				this.showReviewsInTp = false;
			}
			this.showData === true ? this.showData = true :
				(!this.route.snapshot.params.state && !this.amdinNstate.admin ?
					//updated by Fee based SR 4223 Training Centre Pop-up update request
					toastr.info('TC id and password has been sent on SPOC Mobile number and Email to upload photograph through Mobile Application') : this.showData = false);
			this.reviewsOfCma = res.cmaReviews &&
				typeof res.cmaReviews === 'object' &&
				res.cmaReviews.length !== 0 ?
				res.cmaReviews[res.cmaReviews.length - 1].review : null;
			this.removeUnUsualKeysFromPhotos(res.photos);
			this.validateFormFieldReviewSection();
			this.checkAllphotosUploaded();
			// let photosLength = Object.keys(res.photos).length;
			// photosLength !== 0 ? this.createReviewFileds(photosLength) : photosLength = 0;
		});
	}

	validateFormFieldReviewSection() {
		if (this.reviewsOfCma) {
			const reviews = JSON.parse(this.reviewsOfCma);
			if (reviews && reviews.formSectionReview && reviews.formSectionReview.review === 'approved') {
				this.reviewCommentsForForm.patchValue(reviews.formSectionReview);
				// this.reviewCommentsForForm.get('review').disable();
				// this.reviewCommentsForForm.get('comment').disable();
			}
			if (reviews && reviews.formSectionReview && reviews.formSectionReview.review !== 'approved') {
				this.reviewCommentsForForm.patchValue(reviews.formSectionReview);
			}
		}
	}

	addFacilityPhotosInArray() {
		if (this.tcData.feebasedFacilities && typeof this.tcData.feebasedFacilities === 'object') {
			Object.keys(this.tcData.feebasedFacilities).forEach(key => {
				if (typeof this.tcData.feebasedFacilities[key] === 'object') {
					if (this.tcData.feebasedFacilities[key].imgURL) {
						const data = [this.tcData.feebasedFacilities[key]];
						this.tcData.feebasedFacilities[key] = data;
						this.photosAsArray.push({ [key]: this.tcData.feebasedFacilities[key] });
						this.countOfPhotosExit = this.countOfPhotosExit + 1;
					}
				}
				if (typeof this.tcData.feebasedFacilities[key] === 'string') {
					if (this.tcData.feebasedFacilities[key] !== '') {
						const data = [this.tcData.feebasedFacilities[key]];
						this.tcData.feebasedFacilities[key] = data;
						this.photosAsArray.push({ [key]: this.tcData.feebasedFacilities[key] });
						this.countOfPhotosExit = this.countOfPhotosExit + 1;
					}
				}
			});
		}
	}


	checkAllphotosUploaded() {
		if (this.tcData.feebasedFacilities && typeof this.tcData.feebasedFacilities === 'object') {
			Object.keys(this.tcData.feebasedFacilities).forEach(key => {
				if (typeof this.tcData.feebasedFacilities[key] === 'boolean' && this.tcData.feebasedFacilities[key] === true) {
					++this.countOfPhotos;
				}
			});
		}
		if (this.tcData.residentialFacilities && this.tcData.residentialFacilities.totalNumberOfLabs) {
			this.countOfPhotos = this.countOfPhotos + this.tcData.residentialFacilities.totalNumberOfLabs;
		}
		if (this.tcData.residentialFacilities && this.tcData.residentialFacilities.totalNumberOfTrainingRooms) {
			this.countOfPhotos = this.countOfPhotos + this.tcData.residentialFacilities.totalNumberOfTrainingRooms;
		}
		if (this.tcData.residentialFacilities && this.tcData.residentialFacilities.men &&
			this.tcData.residentialFacilities.men.numberOfWashRooms) {
			this.countOfPhotos = this.countOfPhotos + this.tcData.residentialFacilities.men.numberOfWashRooms;
		}
		if (this.tcData.residentialFacilities && this.tcData.residentialFacilities.transgender &&
			this.tcData.residentialFacilities.transgender.numberOfWashRooms) {
			this.countOfPhotos = this.countOfPhotos + this.tcData.residentialFacilities.transgender.numberOfWashRooms;
		}
		if (this.tcData.residentialFacilities && this.tcData.residentialFacilities.women &&
			this.tcData.residentialFacilities.women.numberOfWashRooms) {
			this.countOfPhotos = this.countOfPhotos + this.tcData.residentialFacilities.women.numberOfWashRooms;
		}
		if (this.countOfPhotos && this.countOfPhotosExit) {
			if (this.countOfPhotos === this.countOfPhotosExit) {
				this.isCountOfphotosAndcountOfPhotosExitSame = true;
			} else {
				if (this.amdinNstate && !this.amdinNstate.admin && !this.route.snapshot.params.state) {
					toastr.info('Please upload all selected facility photos through mobile application.');
				}
			}
		}
	}


	removeUnUsualKeysFromPhotos(photos) {
		Object.keys(photos).forEach(facility => {
			Object.keys(photos[facility]).forEach(value => {
				if (value === '') {
					delete photos[facility][value];
				} else {
					const existingKey = this.photosAsArray.find(key => key[facility]);
					if (existingKey && photos[facility][value][0] !== undefined) {
						existingKey[facility].push(photos[facility][value][0]);
						this.countOfPhotosExit = this.countOfPhotosExit + 1;
					} else {
						if (typeof photos[facility][value] === 'object' && photos[facility][value][0] !== undefined) {
							this.photosAsArray.push({
								[facility]: [photos[facility][value][0]]
							});
							this.countOfPhotosExit = this.countOfPhotosExit + 1;
						}
					}
				}
			});
		});

		this.getUrls()
		// this.createReviewFileds(this.photosAsArray, JSON.parse(this.reviewsOfCma));
		// this.photosAsArray.map(ph => {
		// 	console.log(ph);
		// });
		this.createReviewFileds(this.photosAsArray, JSON.parse(this.reviewsOfCma));
	}

	getUrls() {
		this.photosAsArray.map((res, i) => {
			Object.keys(res).forEach(a => {
				this.photosAsArray[i][a].map(b => {
					b = typeof b === 'string' ? b = { imgURL: b } : b;
					if (b.imgURL) {
						this.fileService.getImageURLFeebased(b.imgURL).subscribe(url => {
							b.imgURL = url;
						});
					}
				});
			});
		})
	}

	getFile(url) {
		this.prevImg = url;
		this.modalImage = url.imgURL ? url.imgURL : url ? url : '';
		Helpers.openModal('preview_img');
	}

	createReviewFileds(photos, review) {
		this.reviews = this.reviewCommentsForm.get('reviews') as FormArray;
		for (let i = 0; i <= photos.length - 1; i++) {
			const facilityKey = Object.keys(photos[i]);
			this.reviews.push(this.createReviews(facilityKey, photos[i], [facilityKey], review));
		}
		if (!this.amdinNstate.admin) {
			this.reviewCommentsForm.get('reviews').disable();
		}
	}

	getMobileAppLink() {
		if (this.mobileForm.valid) {
			this.trainingcentreservice.getMobileApkLink(this.mobileForm.value, this.route.snapshot.params.tcId).subscribe(res => {
				toastr.success(`Password reset success`);
				// this.mobileForm.reset();
			}, () => {
				toastr.error('Failed reset password');
			});
		} else {
			// toastr.error('Please enter mobile number.');
			Helpers.markFormGroupTouched(this.mobileForm);
		}
	}


	createReviewAsPerFacility() {
		let x = [];
		const y = {};
		x = JSON.parse(JSON.stringify(this.reviewCommentsForm.get('reviews').value));
		x.filter(res => {
			y[res['facility']] = {
				comment: res.comment,
				review: res.review
			};
		});
		y['formSectionReview'] = this.reviewCommentsForForm.getRawValue();
		return y;
	}

	submitForApproval() {
		if (!this.tcData.photosUploaded) {
			// if (!this.amdinNstate.admin && !this.tcData.photosUploaded) {
			toastr.error('Please upload and save photos from TC Mobile App!');
			return;
		}
		swal({
			title: 'Are you sure you want to submit?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes'
		}).then(result => {
			if (result.value) {
				this.tps.submitTcForApproval({
					UserName: this.route.snapshot.params.tcId,
					submitForApproval: true,
					// schemeID: this.schemeID
				}).subscribe(res => {
					swal({
						title: 'Training centre submitted for approval',
						type: 'success',
						showCancelButton: false,
						confirmButtonText: 'Ok'
					});
					this.back();
				});
			}
		});
	}

	getUpdatedValue() {
		if (this.showData || this.tcData.trainingCenterType === 'Online' || this.tcData.schemeId === "Scheme_1284") {
			const commentsRequired = this.checkCommentsValidation();
			if (this.reviewCommentsForm.valid && !commentsRequired && (this.reviewCommentsForForm.valid || this.reviewCommentsForForm.disabled)) {
				const reviews = {};
				const review = this.createReviewAsPerFacility();
				reviews['review'] = JSON.stringify(this.createReviewAsPerFacility());
				Object.keys(review).forEach(rev => {
					if (review[rev].review === 'Document Required' || this.reviewCommentsForForm.get('review').value === 'Not Approved') {
						// reviews['review'] = 'Document Required';
						reviews['status'] = 'Document Required';
					}
				});
				if (!reviews['status']) {
					reviews['status'] = 'approved';
				}
				reviews['workflowID'] = this.tcworkflow._id;
				reviews['tcId'] = this.tcData.userName;
				// this.reviewDataPhotos.emit(reviews);
				this.trainingcentreservice.approveTCByCMA(reviews).subscribe(() => {
					swal({
						type: 'success',
						title: 'Reviews submitted successfully.',
						// html: `<p>Status: ${+ ' ' + reviews['status']}</p>`,
						showCancelButton: false,
						confirmButtonText: 'Yes'
					});
					this.router.navigate([
						`./continuousmonitoring/view-all-tc-requests`
					]);
				});
			} else {
				toastr.error('Please fill valid data!');
				this.sharedService.markFormGroupTouched(this.reviewCommentsForm);
				this.sharedService.markFormGroupTouched(this.reviewCommentsForForm);
			}
		} else {
			toastr.error('Photos not uploaded!');
		}
	}

	commentsValidation(i, event, comment) {
		if (event.target.value === 'Document Required' && !this.reviewCommentsForm.get('reviews')['controls'][i].controls.comment.value) {
			this.commentsValidationArray[i] = true;
		} else {
			this.commentsValidationArray[i] = false;
		}
		if (comment !== false && event.target.value !== '') {
			this.commentsValidationArray[i] = false;
		}
		// tslint:disable-next-line:max-line-length
		if (comment !== false && event.target.value === '' && this.reviewCommentsForm.get('reviews')['controls'][i].controls.review.value !== 'approved') {
			this.commentsValidationArray[i] = true;
		}
	}

	formInputValidationReview() {
		const data = this.reviewCommentsForForm.get('review').value;
		if (data && data === 'approved') {
			this.sharedService.clearValidators(this.reviewCommentsForForm, 'comment');
		} else {
			this.sharedService.setValidators(this.reviewCommentsForForm, 'comment', [Validators.required]);
		}
	}

	checkCommentsValidation() {
		const commentsRequired = this.commentsValidationArray.find(val => val === true);
		return commentsRequired !== undefined ? true : false;
	}

	openImageModal(url) {
		this.prevImg = url;
		Helpers.openModal('preview_img');
	}

	getProperText(text) {
		return Facility.facilities(text);
	}

	getProperTextFigCaption(text) {
		return Facility.withOutNamePhoto(text);
	}


	back() {
		window.history.go(-2);
	}

	ngDoCheck() {
		if (this.countOfPhotos && this.countOfPhotosExit) {
			// console.log(this.countOfPhotos, this.countOfPhotosExit);

			if (this.countOfPhotos === this.countOfPhotosExit) {
				this.isCountOfphotosAndcountOfPhotosExitSame = true;
			}
		}
	}

}
